module.exports = __webpack_public_path__ + "img/jca-relation.ec760a15.svg";